class CraftGuide extends HTMLElement {
  connectedCallback() {
    this.initScrollspy();
    this.initTocPosition();
    this.initMobileTocPosition();
  }

  initScrollspy() {
    this.links = Array.from(this.querySelectorAll('[data-craft-toc-link]'));
    this.targets = Array.from(this.querySelectorAll('[data-craft-anchor]'));
    if (!this.links.length || !this.targets.length) return;

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: null,
      rootMargin: '-40% 0px -50% 0px',
      threshold: 0,
    });
    this.targets.forEach((target) => this.observer.observe(target));
  }

  initTocPosition() {
    this.toc = this.querySelector('.craft-toc--desktop');
    if (!this.toc) return;

    this.positionToc();
    this.handleResize = () => this.positionToc();
    window.addEventListener('resize', this.handleResize);
  }

  getHeaderHeight() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    const value = parseFloat(raw);
    return Number.isFinite(value) ? value : 47;
  }

  positionToc() {
    if (!this.toc || this.toc.offsetWidth === 0) return;
    const headerHeight = this.getHeaderHeight();
    const viewportHeight = window.innerHeight;
    const tocHeight = this.toc.offsetHeight;
    const centeredTop = headerHeight + (viewportHeight - headerHeight - tocHeight) / 2;
    this.toc.style.top = `${Math.max(headerHeight, centeredTop)}px`;
  }

  initMobileTocPosition() {
    this.mobileToc = this.querySelector('.craft-toc--mobile');
    this.headerWrapper = document.querySelector('.header-wrapper');
    this.sectionHeader = document.querySelector('.section-header');
    if (!this.mobileToc || !this.headerWrapper) return;

    this.updateMobileTocTop = () => {
      this.mobileToc.style.top = `${this.headerWrapper.offsetHeight}px`;
    };
    this.updateMobileTocTop();

    if (this.sectionHeader) {
      this.headerObserver = new MutationObserver(() => {
        this.updateMobileTocTop();
        // .header a une transition padding-top/padding-bottom de 0.3s (sections/header.liquid) :
        // la classe change instantanément mais la hauteur anime après coup, donc on remesure
        // une fois la transition terminée.
        window.setTimeout(this.updateMobileTocTop, 300);
      });
      this.headerObserver.observe(this.sectionHeader, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('resize', this.updateMobileTocTop);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const id = entry.target.id;
      const topicId = entry.target.dataset.topic;
      this.links.forEach((link) => {
        const target = link.dataset.target;
        const isActive = target === id;
        const isContext = target === topicId && topicId !== id;
        link.classList.toggle('is-active', isActive);
        link.classList.toggle('is-context', isContext);
      });
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.handleResize) window.removeEventListener('resize', this.handleResize);
    if (this.headerObserver) this.headerObserver.disconnect();
    if (this.updateMobileTocTop) window.removeEventListener('resize', this.updateMobileTocTop);
  }
}

customElements.define('craft-guide', CraftGuide);
